<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <PropertyTenureListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import PropertyTenureListing from "@/views/pages/admin/propertyTenure/propertyTenureListing";

export default {
    page: {
        title: i18n.t("module.propertyTenure"),
    },
    components: { Layout, PageHeader, PropertyTenureListing },
    data() {
        return {
            title: i18n.t("module.propertyTenure"),
            items: [
                {
                    text: i18n.t("module.property"),
                    href: '/properties',
                },
                {
                    text: i18n.t("module.propertyTenure"),
                    active: true,
                },
            ],
        };
    },
}
</script>
